import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=2a62d025&"
import script from "./PlanCard.vue?vue&type=script&lang=js&"
export * from "./PlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a62d025')) {
      api.createRecord('2a62d025', component.options)
    } else {
      api.reload('2a62d025', component.options)
    }
    module.hot.accept("./PlanCard.vue?vue&type=template&id=2a62d025&", function () {
      api.rerender('2a62d025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/PlanCard.vue"
export default component.exports